import styled from 'styled-components'
import { IconButton } from 'ui/components/Buttons'

export const Box = styled.footer`
  z-index: 1000;
  left: 224px;
  right: 0;
  bottom: 0;
  background: #fff;
  height: 66px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 50px 0 50px;
  border-top: 1px solid ${(p) => p.theme.uiKit.colors.global.grey.grey300};
`

export const DeleteButton = styled(IconButton)`
  margin-right: auto;
`
